import React, { useState } from 'react';
import logo from './logo.svg';
import Builder from './pages/Builder';
import AddData from './pages/AddData';
import Login from './pages/LogIn';
import Error from './pages/Error';
import lscLogo from './images/invoice-logo.png'
import './App.css';
import { AnimatePresence, motion } from "framer-motion";
import ConfirmDialog from "./components/ConfirmDialog";
import DeleteCustomerPopup from './components/DeleteCustomerPopup'

function App() {
  const [page,setPage] = useState<string>("login");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage,setNotificationMessage] = useState<string>("");
  const [dialog, setDialog] = useState<React.ReactNode>(null);
  const [isDeletePopupVisible, setIsDeletePopupVisible] = useState(false);

  const notify = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  
  const confirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      const handleResolve = (result: boolean) => {
        setDialog(null);
        resolve(result);
      };
      setDialog(<ConfirmDialog message={message} onResolve={handleResolve} />);
    });
  };

  return (
    <motion.div className='bg-image full'
      initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.3 }}
    >
      <AnimatePresence>
        {showNotification && (
          <motion.div
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transition={{ duration: 0.5 }}
            className='notification'
          >
            {notificationMessage}
          </motion.div>
        )}
      </AnimatePresence>
      <div className='top-banner'>
        <img
          src={lscLogo}
          alt="Invoice Logo"
          className='logo-img'
        />
      </div>
      {dialog}
      <DeleteCustomerPopup
        isVisible={isDeletePopupVisible}
        onClose={() => setIsDeletePopupVisible(false)}
      />
      {page === "builder" ? (
        <Builder setNotificationMessage={setNotificationMessage} notify={notify} setPage={setPage} confirm={confirm} setIsDeletePopupVisible={setIsDeletePopupVisible} isDeletePopupVisible={isDeletePopupVisible}/>
      ) : page === "addData" ? (
        <AddData setNotificationMessage={setNotificationMessage} notify={notify} setPage={setPage}/>
      ) : page === "login" ? (
        <Login setPage={setPage}/>
      ) : (
        <Error />
      )}

      <footer className='footer'>
        <small>© 2025 London Science College. All Rights Reserved.</small>
        <small>Designed by Jadid Alam</small>
      </footer>
    </motion.div>

  );
}

export default App;
